// extracted by mini-css-extract-plugin
export var hideEditor = "_l2-2";
export var infoIcon = "_l2-3";
export var label = "_l2-1";
export var labelContainer = "_l2-0";
export var readonlyText = "_l2-4";